import type { ReactNode } from 'react'
import { Languages } from 'lucide-react'
import { useI18n } from '@/i18n'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import { Brand } from './brand'

export type AuthLayoutProps = { children: ReactNode; title?: ReactNode; description?: ReactNode; className?: string }

export function AuthLayout({ children, title, description, className }: AuthLayoutProps) {
  const { locale, toggleLocale, t } = useI18n()
  const zh = locale === 'zh-CN'
  return (
    <div className='flex min-h-svh flex-col bg-background'>
      <header className='flex items-center justify-between gap-4 border-b px-4 py-4 md:px-6'>
        <Brand />
        <Button type='button' variant='ghost' size='sm' onClick={toggleLocale} aria-label={zh ? '切换为英文' : 'Switch to Chinese'}>
          <Languages aria-hidden='true' />{zh ? 'English' : '中文'}
        </Button>
      </header>
      <main className='flex flex-1 items-center justify-center px-4 py-10 md:py-16'>
        <div className={cn('w-full max-w-md space-y-6', className)}>
          {(title || description) && <div className='space-y-2 text-center'>
            {title && <h1 className='text-2xl font-semibold tracking-tight'>{title}</h1>}
            {description && <p className='text-sm leading-6 text-muted-foreground'>{description}</p>}
          </div>}
          {children}
        </div>
      </main>
      <footer className='px-4 pb-6 text-center text-xs text-muted-foreground'>{t('identityHint')}</footer>
    </div>
  )
}
